import {
  Carousel as BootstrapCarousel,
  type CarouselProps
} from 'react-bootstrap';
import './Carousel.scss';

export const Carousel = (props: CarouselProps) => {
  return <BootstrapCarousel className="cw-carousel" {...props} />;
};

// Export the Carousel.Item and Carousel.Caption for convenience
Carousel.Item = BootstrapCarousel.Item;
Carousel.Caption = BootstrapCarousel.Caption;

export type { CarouselProps } from 'react-bootstrap';
